/**
 * Deal (order) statuses. Open (work goes on) = `taken | done`. AUT-546: an
 * order starts as an offer — `proposed` waits for the client, who accepts
 * (`taken`) or declines (`declined`); the owner or the system may withdraw it
 * (`withdrawn`). Append-only.
 */
export const DEAL_STATUSES = [
    'taken',
    'done',
    'confirmed',
    'cancelled',
    'closed_unconfirmed',
    'proposed',
    'declined',
    'withdrawn',
];
/**
 * «The chat already has an order»: an offer waiting for the client or an open
 * deal. At most one per chat (`deals_one_open_per_chat`); every «existing deal
 * in chat» lookup and the `take` / `propose` gate use this set.
 */
export const DEAL_ACTIVE_STATUSES = ['proposed', 'taken', 'done'];
/** An offer that ended without becoming an order: not an order, not in the owner's lists. */
export const DEAL_OFFER_CLOSED_STATUSES = ['declined', 'withdrawn'];
/** Internal keys; labels («Осмотр», «Подбор авто», «Авто под заказ») are i18n. Append-only. */
export const DEAL_KINDS = ['inspection', 'selection', 'import', 'handover', 'day'];
/**
 * AUT-592 — where the order came from. `chat`: an offer the client accepted in
 * a chat (client, chat and price are set). `internal`: the profile owner's own
 * order — no client, no chat, no price. Persisted (`deals.origin`); append-only.
 */
export const DEAL_ORIGINS = ['chat', 'internal'];
/**
 * Assignees on one deal — the business limit. The api enforces it with 422
 * `too_many_assignees` on `PUT /deals/:id/assignees` and on the `memberIds`
 * of `POST /deals`.
 */
export const DEAL_ASSIGNEES_MAX = 10;
/**
 * Parse-time bound on the `memberIds` of `POST /deals`, against oversized
 * bodies: `parseDealInternalInput` refuses a longer array as sent
 * (`assignees_invalid`, 400) before reading an id. Not the business limit —
 * that is `DEAL_ASSIGNEES_MAX`, so 11 to 100 ids reach the api's 422.
 */
export const DEAL_MEMBER_IDS_PARSE_MAX = 100;
/**
 * AUT-592 — the profile owner's own order: no client, no chat, no price. The
 * one origin test a client branches on; never compare `chatId` to `null`.
 */
export function isInternalDeal(v) {
    return v.origin === 'internal';
}
/** AUT-592 — narrows a view to one with a chat: the only way to read `chatId` as a string. */
export function hasDealChat(v) {
    return v.chatId !== null;
}
//# sourceMappingURL=deal.js.map